// extracted by mini-css-extract-plugin
export default {"company-banner":"company-banner--VfbGF","companyBanner":"company-banner--VfbGF","heading":"heading--g8SlP","text":"text--VMLvX","link":"link--IJlr_","blink":"blink--Lqw7L"};